<template>
  <div class="container">
    <div class="content" :class="{bgWhite:tab==0|tab==2,bgGray:tab==1|tab==3}">
      <!-- <better-scroll class="nav" :scrollX="true"> -->
      <div class="nav">
        <div class="wrapper">
          <span
            class="item"
            v-for="(item,index) in navList"
            :key="index"
            :class="{'item_active':item.select}"
            @click="goPage(index,item)"
          >{{item.type}}</span>
        </div>
      </div>
      <!-- </better-scroll> -->
    </div>
    <div class="fiedBox"></div>
    <router-view class="child-view"></router-view>
  </div>
</template>

<script>
import api from "../../../../service/modules/appointment";
// import betterScroll from '../../../components/base/betterScroll'
// import betterScroll from '../../../components/base/betterScroll'

export default {
  components: {
    // 'better-scroll': betterScrollviews
  },
  data() {
    return {
      navList: [],
      tab: "",
      cityList: []
    };
  },
  created() {
    // this.getCity();
    
    this.initTab();
  },
  methods: {
    // 初始化tab选中项
    initTab() {
      this.navList = [
        {
          type: "资源概况",
          select: true,
          path: "/resourcesManage/home/profile"
        },
        {
          type: "地理分布",
          select: false,
          path: "/resourcesManage/home/distribution"
        },
        { type: "占比分析",
          select: false, 
          path: "/resourcesManage/home/analysis"
        }
      ];
      switch(this.$route.path) {
        case "/resourcesManage/home/profile":
        this.navList[0].select = true;
        break;
        case "/resourcesManage/home/distribution":
        this.navList[1].select = true;
        this.navList[0].select = false;
        break;
        case "/resourcesManage/home/analysis":
        this.navList[2].select = true;
        this.navList[0].select = false;
        break;
      }
    },
    /** 获取城市 */
    getCity() {
      api.city({ areaCode: this.$route.query.areaCode }).then(res => {
        let level = res.data[0].level;
        if (level === 1) {
          let arr = res.data[0].child.map(
            ({ fullName, areaCode, shortName, level, child }) => {
              return {
                text: fullName,
                value: areaCode,
                shortName,
                level,
                child: child
                  ? child.map(({ fullName, areaCode, shortName, level }) => {
                      return {
                        text: fullName,
                        value: areaCode,
                        shortName,
                        level
                      };
                    })
                  : []
              };
            }
          );
          this.cityList = arr;
        } else if (level === 2) {
          this.cityList = res.data.child.map(
            ({ fullName, areaCode, shortName, level, child }) => {
              return {
                text: fullName,
                value: areaCode,
                shortName: shortName,
                level: level,
                child: child
              };
            }
          );
        } else if (level === 3) {
          this.cityList = res.data.child.map(
            ({ fullName, areaCode, shortName, level, child }) => {
              return {
                text: fullName,
                value: areaCode,
                shortName: shortName,
                level: level,
                child: child
              };
            }
          );
        }
      });
    },
    goPage(index, item) {
      this.tab = index;
      this.$router.replace(item.path);
      this.navList.map((item, i) => {
        this.$set(this.navList[i], "select", false);
      });
      this.$set(this.navList[index], "select", true);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  .content {
    width: 100%;
    padding: 10px 2px 2px;
    box-sizing: border-box;
    overflow: hidden;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 999;
    .nav {
      width: 100%;
      height: 40px;
      .wrapper {
        white-space: nowrap;
        position: absolute;
        .item {
          display: inline-block;
          padding: 10px;
          // border-bottom: 2px solid @base-color;
          font-size: 14px;
        }
        .item_active {
          border-bottom: 2px solid @base-color;
          padding-bottom: 6px;
          color: @base-color;
          font-weight: 600;
          padding-left: 0;
          padding-right: 0;
          margin: 0 10px;
        }
      }
    }
  }
  .bgWhite {
    background-color: #fff;
  }
  .bgGray {
    background-color: #fbfbfb;
  }
  .fiedBox {
    height: 50px;
    width: 100%;
  }
  .child-view {
    margin-top: 1px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 50px;
    line-height: 50px;
    margin-top: 50px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
</style>
